import { render, staticRenderFns } from "./TipoDesconto.vue?vue&type=template&id=159eec04&"
import script from "./TipoDesconto.vue?vue&type=script&lang=js&"
export * from "./TipoDesconto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports